// extracted by mini-css-extract-plugin
export default {"body":"styles_body__okzeV","productName":"styles_productName__suUjw"};